import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { revealPrerender } from './lib/prerender.js';
import './index.css';
// V2 design system (tokens, components, app shell, marketing chrome). Must stay after index.css.
import './styles/v2.css';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Marketing pages ship prerendered Arabic markup (scripts/postbuild-seo.mjs,
// hidden by #root[data-pre] until revealed). Hydrate it in place when it
// matches what the client will render; otherwise start from an empty root.
let locale = 'ar';
try { locale = localStorage.getItem('locale') || 'ar'; } catch { /* private mode */ }
const prerendered =
  container.hasAttribute('data-pre') &&
  locale === 'ar' &&
  !window.location.pathname.startsWith('/embed/') && // booking inside other sites: no marketing markup to hydrate
  window.location.hostname.toLowerCase() !== 'business.cardpass.co';

if (prerendered) {
  ReactDOM.hydrateRoot(container, app);
  // Safety net: never leave the page hidden if the page's own reveal is missed.
  window.setTimeout(revealPrerender, 4000);
} else {
  if (container.hasAttribute('data-pre')) {
    container.textContent = '';
    container.removeAttribute('data-pre');
  }
  ReactDOM.createRoot(container).render(app);
}

